import { render, staticRenderFns } from "./MyPrefecture.vue?vue&type=template&id=1bc1c947&scoped=true&"
import script from "./MyPrefecture.vue?vue&type=script&lang=js&"
export * from "./MyPrefecture.vue?vue&type=script&lang=js&"
import style0 from "./MyPrefecture.vue?vue&type=style&index=0&id=1bc1c947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1c947",
  null
  
)

export default component.exports